import { toPlainText } from '@portabletext/toolkit';
import { PortableTextBlock } from '@portabletext/types';

const isStringifiedPortableText = (text: string) => text.startsWith('[{') && text.endsWith('}]');
const parsePortableText = (text: string) => JSON.parse(text) as PortableTextBlock[];
const stringifyPortableText = (blocks: PortableTextBlock[]) => JSON.stringify(blocks);
const portableTextToPlainText = (blocks: PortableTextBlock[]) => toPlainText(blocks);

export { isStringifiedPortableText, parsePortableText, stringifyPortableText, portableTextToPlainText };
